/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { Backdrop, CircularProgress, Grid, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useObserver } from "mobx-react-lite";
import {
  useTrackMetric,
  useAppInsightsContext,
} from "@microsoft/applicationinsights-react-js";
import cancel from "../../assets/cancel.png";
import ok from "../../assets/ok.png";
import { useGlobalStore } from "../../state/GlobalStore";
import { apiService } from "../../services/ApiService";
import { helperMethods } from "../../hooks/helper";
import { AppInsightsConstants, ConstantVariables } from "../../Constants";
import { AppInsightMethods } from "../../AppInsightMethods";
import { IDeleteRelationSettings } from "../../state/GlobalStateType";

interface IRelationButton {
  callBackGetRelatnList: () => void;
  popup: boolean;
  closeCallback: () => void;
}

export default function DeleteRelationSettings(props: IRelationButton) {
  const pageName = "Delete Relationship settings";
  const appInsights = useAppInsightsContext();
  const globalStore = useGlobalStore();
  const helper = helperMethods();
  const [showSpinner, setShowSpinner] = React.useState(false);
  const [alertMeassage, setalertMeassage] = React.useState(false);
  const trackComponent = useTrackMetric(appInsights, pageName);

  useEffect(() => {
    trackComponent();
  }, []);
  const handleClose = () => {
    try {
      if (!props.popup) {
        globalStore.setOpenedModalRelation("none");
        globalStore.setActionMenuSelectedRelationship(null);
        setalertMeassage(false);
        AppInsightMethods.trackAppInsightsEvent(
          pageName,
          AppInsightsConstants.Information,
          `Delete Relationship settings close/cancel button click event.`,
          globalStore.loginUserEmail,
          window.location.href,
          ""
        );
      }
    } catch (error) {
      AppInsightMethods.TrackAppInsightsException(
        `Error at handleClose, Component: ${pageName}, Error: ${error}`
      );
    }
  };

  const onOkbtnClick = () => {
    try {
      const delRelatnSettings: IDeleteRelationSettings = {
        id: globalStore.actionMenuSelectedRelationship?.id,
        relation: globalStore.actionMenuSelectedRelationship?.relation,
        uploadedTime: globalStore.actionMenuSelectedRelationship?.uploadedTime,
        uploadedBy: globalStore.actionMenuSelectedRelationship?.uploadedBy,
      };
      setShowSpinner(true);
      AppInsightMethods.trackAppInsightsEvent(
        pageName,
        AppInsightsConstants.Information,
        `Delete Relationship settings ok button click event. Relationship Name: ${globalStore.actionMenuSelectedRelationship?.relation}`,
        globalStore.loginUserEmail,
        window.location.href,
        ""
      );
      apiService
        .delRelationsettings(delRelatnSettings)
        .then((res: any) => {
          setShowSpinner(false);
          setalertMeassage(false);
          if (res === "success") {
            helper.setSuccessMessageEvent(
              "Relationship settings deleted successfully!"
            );
          }
          AppInsightMethods.trackAppInsightsEvent(
            pageName,
            AppInsightsConstants.Information,
            `Delete API call success.`,
            globalStore.loginUserEmail,
            window.location.href,
            ""
          );
          handleClose();
          props.closeCallback();
          props.callBackGetRelatnList();
        })
        .catch((error: any) => {
          AppInsightMethods.TrackAppInsightsException(
            `Error at Delete Relationship settings, Component: ${pageName}, Error: ${error}`
          );
          setShowSpinner(false);
          setalertMeassage(true);
        });
    } catch (error) {
      AppInsightMethods.TrackAppInsightsException(
        `Error at onOkbtnClick, Component: ${pageName}, Error: ${error}`
      );
    }
  };

  return useObserver(() => {
    return (
      <>
        <Dialog open={props.popup} onClose={handleClose}>
          <Grid className="deleteDialogRelatn">
            <DialogTitle className="titleDeleteRelatn">
              <b style={{ marginRight: 353 }}>Delete</b>
              <IconButton
                onClick={() => {
                  handleClose();
                  props.closeCallback();
                }}
              >
                <CloseRoundedIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              <DialogContentText className="contentTextRelatn">
                Are you sure you want to delete{" "}
                <span className={"textBoldRelatn"}>
                  {globalStore.actionMenuSelectedRelationship?.relation}
                </span>
                &nbsp;relationship ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  handleClose;
                  props.closeCallback();
                }}
                className="btnStyleRelatn"
              >
                <img
                  src={cancel}
                  alt="cancel"
                  className="logo pointer cursor"
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role="button"
                  tabIndex={0}
                />
              </Button>
              <Button
                onClick={() => onOkbtnClick()}
                style={{ paddingRight: "2rem" }}
              >
                <img
                  src={ok}
                  alt="ok"
                  className="logo pointer cursor"
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role="button"
                  tabIndex={0}
                />
              </Button>
            </DialogActions>
            {alertMeassage && (
              <span className={"errorMessage deleteMaterialDialogRelatn"}>
                {ConstantVariables.Common_Error_Text}
              </span>
            )}
          </Grid>
        </Dialog>
        {showSpinner && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
            open={showSpinner}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </>
    );
  });
}
